<template>
	<xaoi-win title="选择医生" v-model="show">
		<div class="conn">
			<div class="sels">
				搜索：<div class="sel"><el-input clearable v-model="sel.name" size="small" placeholder="医生姓名" @change="on.reload"></el-input></div>
			</div>
			<div class="db">
				<el-table ref="tab" v-loading="tab_loading" class="eltab" height="400" :data="tab.data" row-key="id" border @select="on.sel" @select-all="on.sel">

					<el-table-column type="selection" width="55"> </el-table-column>

					<el-table-column label="头像">
						<template slot-scope="scope">
							<xaoi-img v-if="scope.row.head_portrait_pic" :src="scope.row.head_portrait_pic[0].url"></xaoi-img>
						</template>
					</el-table-column>

					<el-table-column prop="real_name" label="姓名"></el-table-column>

					<el-table-column prop="department_id_text" label="科室"></el-table-column>

				</el-table>
			</div>
			<div class="footer">
				<div class="page"></div>
				<div class="buts">
					<el-button size="small" @click="show = false">取 消</el-button>
					<el-button size="small" type="primary" @click="submit()" :loading="is_load">提 交</el-button>
				</div>
			</div>
		</div>
	</xaoi-win>
</template>

<style lang="scss" scoped>
.conn{
	width:800px;
	.sels{
		padding:10px 15px 0;
		.sel{
			display: inline-block;
		}
	}
	.db{
		padding:10px 15px 10px;
		.eltab{
			.xaoi_img{
				width:80px;
			}
		}
	}
	.footer{
		display: flex;border-top:1px solid #DCDFE6;padding:15px;
		.page{
			flex:1;
		}
		.buts{
			text-align: right;
		}
	}
}
</style>

<script>
export default {
	data(){
		var vue = this;

		return {
			show:false,
			tab_loading:false,
			is_load:false,
			sel:{
				name:'',
				ids:[],
			},
			tab:{
				data:[],
			},
			on:{
				async up(){
					vue.tab_loading = true;
					var [code,data] = await vue.ajax2('set/DiseaseType/get_doctor',{
						sousuo:vue.sel.name,
					});
					vue.tab_loading = false;
					switch(code){
						case 0:
							vue.$set(vue.tab,'data',data)
						break;
					}
				},
				reload(){
					vue.on.up();
				},
				sel(d){
					vue.$set(vue.sel,'ids',[])
					for(var v of d){
						vue.sel.ids.push(v.id)
					}
				},
				async upsel(){
					vue.$refs.tab.clearSelection();
					await new Promise(ok=>vue.$nextTick(ok))
					for(var i in vue.tab.data){
						if(vue.sel.ids.indexOf(vue.tab.data[i].id) !== -1){
							vue.$refs.tab.toggleRowSelection(vue.tab.data[i]);
						}
					}
				}
			},
			async init(d){
				vue.init_d = d
				
				vue.show = true;

				var [code,data] = await vue.ajax2('set/DiseaseType/is_doctor',{id:d.id})
				switch(code){
					case 0:
						var lis = [];
						for(var v of data){
							lis.push(v.user_id)
						}
						vue.$set(vue.sel,'ids',lis);
					break;
				}
				
				await new Promise(ok=>vue.$nextTick(ok))
				vue.on.upsel();
			},
			async submit(){
				vue.is_load = true;
				var [code,data] = await vue.ajax2('set/DiseaseType/set_doctor',{
					id:vue.init_d.id,
					ids:vue.sel.ids.join(','),
				})
				vue.is_load = false;
				switch(code){
					case 0:
						vue.$message({message: '设置成功',type: 'success'});
					break;
				}
				vue.show = false;
			},
		}
	},
	created(){
		this.on.up();
	}
}
</script>